import { setSpecificMessage, imei } from "valibot";
setSpecificMessage(
  imei,
  (issue) => `IMEI invalide: reçu ${issue.received}`,
  "fr"
);